import React, { useContext } from "react";
import { SiteContext } from "@arcteryx/components-contexts";
import Script from "./Script";

// env: production | preprod | stage | qa
const UIComponentsScript = ({ uiBaseUrl = '', env, loadFooter = true, ...props }) => {
  const { market, country, language } = useContext(SiteContext);
  const headerUrl = `${uiBaseUrl}/${country}/${language}/${market}Header.js`;
  const footerUrl = `${uiBaseUrl}/${country}/${language}/${market}Footer.js`;
  const marketUCFirst = market.charAt(0).toUpperCase() + market.slice(1);
  const localeSwitcherUrl = `${uiBaseUrl}/${country}/${language}/localeSwitcher${marketUCFirst}.js`;

  return (
    <React.Fragment>
      <Script url={headerUrl} {...props} />
      {loadFooter ? <Script url={footerUrl} async={false} defer={true} {...props} /> : null}
      {market !== "leaf" ? <Script url={localeSwitcherUrl} async={false} defer={true} {...props} /> : null}
    </React.Fragment>
  );
};

export default UIComponentsScript;
